
const AWS = require('aws-sdk');
const { SuccessResponse, ErrorResponse, ERROR, Status } = require("./response");
const { GetSecretC } = require("./aws-secrets");
const { create_jwt } = require("./token");
const { Region, Stage} = require("./env");
const { GetParametersC } = require("./aws-ssm");
const crypto = require('crypto');
const {sprintf} = require("sprintf-js");

let USER_POOL_ID;
let USER_POOL_CLIENT_ID;
let IDENTITY_POOL_IDS;
let AWS_ACCOUNT_ID;

let VERB = false;

if (process.env.CA_USER_POOL_ID) {
  USER_POOL_ID = process.env.CA_USER_POOL_ID;
}

if (process.env.CA_USER_POOL_ARN) {
  // If we specify the ARN, then parse off the userPoolId off the end.
  USER_POOL_ID = process.env.CA_USER_POOL_ARN.split("/").pop();
}

if (process.env.CA_USER_POOL_CLIENT_ID) {
  USER_POOL_CLIENT_ID = process.env.CA_USER_POOL_CLIENT_ID;
}

if (process.env.CA_AWS_ACCOUNT_ID) {
  AWS_ACCOUNT_ID = process.env.CA_AWS_ACCOUNT_ID;
}

if (process.env.CA_COGNITO_DEBUG) {
  VERB = process.env.CA_COGNITO_DEBUG;
}

const SetCognitoVerb = verb => {
  VERB = verb;
}

if (process.env.CA_IDENTITY_POOL_IDS) {
  IDENTITY_POOL_IDS = process.env.CA_IDENTITY_POOL_IDS
    .split(",")
    .map(arn => arn.split("/").pop());
}

/**
 *
 * @param user_pool_id {string}
 * @param user_pool_client_id {string}
 * @param identity_pools_ids {string[]}
 * @param aws_account_id {string}
 */
const BootStrap = (
  user_pool_id, user_pool_client_id,
  identity_pools_ids, aws_account_id) => {
  USER_POOL_ID = user_pool_id;
  USER_POOL_CLIENT_ID = user_pool_client_id;
  IDENTITY_POOL_IDS = identity_pools_ids;
  AWS_ACCOUNT_ID = aws_account_id;
}

const BootStrapSUT = async (creds) => {
  const user_pool_prm = sprintf("/stack/%s-SUT/user-pool-arn", Stage.stage);
  const client_id_prm = sprintf("/stack/%s-SUT/user-pool-client-id", Stage.stage);
  const id_pools_prm = sprintf("/stack/%s-SUT/identity-pool-arns", Stage.stage);
  const account_id_prm = sprintf("/stack/%s-SUT/account-id", Stage.stage);
  const resp = await GetParametersC(creds, [
    user_pool_prm, client_id_prm, id_pools_prm, account_id_prm]);
  if (resp.status === Status.ERROR) {
    return resp;
  }
  USER_POOL_ID = resp.payload[user_pool_prm].split("/").pop();
  USER_POOL_CLIENT_ID = resp.payload[client_id_prm];
  if (resp.payload[id_pools_prm]) {
    IDENTITY_POOL_IDS = resp.payload[id_pools_prm].split(",")
      .map(id => id.split("/").pop());
  }
  AWS_ACCOUNT_ID = resp.payload[account_id_prm];
  if (VERB) {
    console.log("BOOTSTRAP");
    console.log(user_pool_prm, "->", USER_POOL_ID);
    console.log(client_id_prm, "->", USER_POOL_CLIENT_ID);
    console.log(id_pools_prm, "->", IDENTITY_POOL_IDS);
    console.log(account_id_prm, "->", AWS_ACCOUNT_ID);
  }
  return SuccessResponse("OK");
}

const getUserPoolId = () => {
  return USER_POOL_ID;
}

const get_isp = (creds) => {

  if (creds) {
    return new AWS.CognitoIdentityServiceProvider(creds.to_service());
  }

  const region = Region.region;
  if (region) {
    return new AWS.CognitoIdentityServiceProvider({
      region
    });
  }
  return new AWS.CognitoIdentityServiceProvider();
}

const get_identity_service = creds => {
  if (creds) {
    return new AWS.CognitoIdentity(creds.to_service());
  }
  if (Region.region) {
    return new AWS.CognitoIdentity({
      region: Region.region,
    })
  }
  return new AWS.CognitoIdentity();
}


const maybe_assign_custom_attribute = (result, attribs, custom_id, prop) => {
  const attr = attribs.find(item => item.Name === "custom:" + custom_id);
  if (attr) {
    result[prop] = attr.Value;
  }
}

const user_to_obj = user => {
  const attribs = user.UserAttributes || user.Attributes;
  const result = {
    username: user.Username,
    email: attribs.find(
      item => item.Name === 'email').Value,
    name: attribs.find(
      item => item.Name === "name").Value,
  }
  maybe_assign_custom_attribute(result, attribs, "confirmed", "confirmed");
  maybe_assign_custom_attribute(result, attribs, "wlf-id", "wlf_id");
  maybe_assign_custom_attribute(result, attribs, "account-type", "account_type");
  maybe_assign_custom_attribute(result, attribs, "identity-id", "identity_id");
  maybe_assign_custom_attribute(result, attribs, "account-states", "account_states");
  if (result.account_states) {
    result.account_states = JSON.parse(result.account_states);
  }
  if ('confirmed' in result) {
    result.confirmed = result.confirmed === "true";
  }
  return result;
};

const AdminListUsers = async (username_prefix, pagination_token) => {
  return await AdminListUsersC(null, username_prefix, pagination_token);
}

const AdminListUsersC = async (creds, username_prefix, pagination_token) => {

  const params = {
    UserPoolId: getUserPoolId(),
    PaginationToken: pagination_token,
  }
  if (username_prefix) {
    params.Filter = "username ^= \"" + username_prefix + "\"";
  }

  const identityServiceProvider = get_isp(creds);

  try {
    if (VERB) {
      console.log("aws-cognito: listUsers", params);
    }
    const response = await identityServiceProvider.listUsers(params).promise();
    const users = response.Users.map(user => {
      return {
        username: user.Username,
        ...user_to_obj(user),
      }
    });

    return SuccessResponse({
      users: users || [],
      page_token: response.PaginationToken,
    });
  } catch (err) {
    if (VERB) {
      console.log(err);
    }
    return ErrorResponse(err);
  }
}

const AdminListAllUsers = async (username_prefix) => {
  return await AdminListAllUsersC(null, username_prefix);
}

const AdminListAllUsersC = async (credentials, username_prefix) => {

  let users = [];
  let page_token;

  while (true) {
    let resp = await AdminListUsersC(credentials, username_prefix, page_token);
    if (resp.status === ERROR) {
      return resp;
    }
    users = users.concat(resp.payload.users);
    page_token = resp.payload.page_token;
    if (!page_token) {
      break;
    }
  }

  return SuccessResponse(users);
}

const AdminGetUser = async (username) => {
  return await AdminGetUserC(null, username);
}

const AdminGetUserC = async (credentials, username) => {

  const params = {
    UserPoolId: getUserPoolId(),
    Username: username,
  };

  const identityServiceProvider = get_isp(credentials);

  try {
    if (VERB) {
      console.log("aws-cognito: adminGetUser", params);
    }
    return SuccessResponse(
      user_to_obj(
        await identityServiceProvider.adminGetUser(params).promise()));
  } catch (err) {
    if (VERB) {
      console.log(err);
    }
    return ErrorResponse(err);
  }
};

const AdminUpdateUserAttributes = async (username, attribs) => {
  return await AdminUpdateUserAttributesC(null, username, attribs);
}

/**
 * @param credentials {CaCredentials|null}
 * @param username: {string} <wlf_id>_<email>
 * @param attribs: [{ Name: str, Value: str }]
 */
const AdminUpdateUserAttributesC = async (credentials, username, attribs) => {

  const identityServiceProvider = get_isp(credentials);

  const params = {
    UserAttributes: attribs,
    UserPoolId: getUserPoolId(),
    Username: username,
  };

  try {
    if (VERB) {
      console.log("aws-cognito: adminUpdateUserAttributes", params);
    }
    return SuccessResponse(
      await identityServiceProvider.adminUpdateUserAttributes(params).promise());
  } catch (err) {
    if (VERB) {
      console.log(err);
    }
    return ErrorResponse(err);
  }
};

const AdminSetUserPassword = async (username, is_permanent, password) => {
  return await AdminSetUserPasswordC(
    null, username, is_permanent, password);
}

const AdminSetUserPasswordC = async (credentials, username, is_permanent, password) => {
  const params = {
    UserPoolId: getUserPoolId(),
    Username: username,
    Permanent: is_permanent,
    Password: password,
  };

  const identityServiceProvider = get_isp(credentials);

  try {
    if (VERB) {
      console.log("aws-cognito: adminSetUserPassword", params);
    }
    return SuccessResponse(
      await identityServiceProvider.adminSetUserPassword(params).promise());
  } catch (err) {
    if (VERB) {
      console.log(err);
    }
    return ErrorResponse(err);
  }
};

const AdminCreateUser = async (creds, user, tmp_password) => {
  const params = {
    UserPoolId: getUserPoolId(),
    Username: user.username,
    DesiredDeliveryMediums: [ 'EMAIL' ],
    MessageAction: "SUPPRESS",
    TemporaryPassword: tmp_password,
    UserAttributes: [
      {
        Name: 'email',
        Value: user.email,
      },
      {
        Name: 'name',
        Value: user.name,
      },
      {
        Name: 'custom:account-type',
        Value: user.account_type,
      },
    ],
  };

  if ('wlf_id' in user) {
    params.UserAttributes.push({
      Name: 'custom:wlf-id',
      Value: user.wlf_id,
    })
  }
  if ('confirmed' in user) {
    params.UserAttributes.push({
      Name: 'custom:confirmed',
      Value: user.confirmed ? "true" : "false",
    })
  }
  if ('identity_id' in user) {
    params.UserAttributes.push({
      Name: 'custom:identity-id',
      Value: user.identity_id,
    })
  }
  if ('account_states' in user) {
    params.UserAttributes.push({
      Name: 'custom:account-states',
      Value: JSON.stringify(user.account_states),
    })
  }

  const isp = get_isp(creds);

  try {
    if (VERB) {
      console.log("aws-cognito: adminCreateUser", params);
    }
    const resp = await isp.adminCreateUser(params).promise();
    if (resp.User) {
      return SuccessResponse(user_to_obj(resp.User));
    }
    return ErrorResponse(resp);
  } catch (err) {
    if (VERB) {
      console.log(err);
    }
    return ErrorResponse(err);
  }
}

const CreateUserPasswordToken = async (username, password) => {
  return await CreateUserPasswordTokenC(null, username, password);
}

const CreateUserPasswordTokenC = async (creds, username, password) => {
  let resp = await GetSecretC(creds, "cognito");
  if (resp.status === ERROR) {
    return resp;
  }
  const key = resp.payload.tmp_pass_secret;

  return create_jwt( { username, password }, key, "7d");
}

/**
 * username to wlf_id/email
 */
const SplitUsername = username => {
  const userRE = /^([^_]+)_(.+)$/;
  const match = username.match(userRE);
  if (!match) {
    return ErrorResponse("username parse error " + username);
  }
  return SuccessResponse({
    wlf_id: match[1],
    email: match[2],
  });
}

let CLIENT_SECRET = "";

const get_client_secret = async () => {
  return await get_client_secret_c(null);
}

const get_client_secret_c = async (creds) => {
  if (CLIENT_SECRET !== "") {
    return SuccessResponse(CLIENT_SECRET);
  }

  const resp = await GetSecretC(creds, "cognito");
  if (resp.status === Status.ERROR) {
    return resp;
  }

  CLIENT_SECRET = Stage.stage === "prod"
    ? resp.payload.prod_client_secret
    : resp.payload.dev_client_secret;

  return SuccessResponse(CLIENT_SECRET);
}

/**
 * Login a user using Cognito.
 * @param creds {CaCredentials|null}
 * @param username {string}
 * @param password {string}
 */
const AuthUser = async (creds, username, password) => {
  const identityServiceProvider = get_isp(creds);

  const s_resp = await get_client_secret_c(creds);

  if (s_resp.status === Status.ERROR) {
    return s_resp;
  }

  const secret = s_resp.payload;
  const client_id = USER_POOL_CLIENT_ID;
  const secretHash = crypto.createHmac('SHA256', secret)
    .update(username + client_id).digest('base64');

  const params = {
    AuthFlow: "ADMIN_NO_SRP_AUTH",
    ClientId: client_id,
    UserPoolId: getUserPoolId(),
    AuthParameters: {
      USERNAME: username,
      PASSWORD: password,
      SECRET_HASH: secretHash
    }
  };

  try {
    return SuccessResponse(
      await identityServiceProvider.adminInitiateAuth(params).promise());
  } catch (err) {
    return ErrorResponse(err);
  }
}

/**
 * Gets the identity id from an id token.
 * @param creds {CaCredentials|null}
 * @param id_token {string}
 * @param identity_pool_index {string}
 */
const GetIdentityId = async (creds, id_token, identity_pool_index) => {

  const id_service = get_identity_service(creds);

  const id_provider_name = 'cognito-idp.' + Region.region + '.amazonaws.com/'
    + USER_POOL_ID;

  const params = {
    IdentityPoolId: IDENTITY_POOL_IDS[identity_pool_index],
    AccountId: AWS_ACCOUNT_ID,
    Logins: {
      [id_provider_name]: id_token,
    }
  };

  try {
    return SuccessResponse(await id_service.getId(params).promise());
  } catch (err) {
    return ErrorResponse(err);
  }

}

const AdminDeleteUser = async (creds, username) => {
  const params = {
    UserPoolId: getUserPoolId(),
    Username: username,
  }

  const isp = get_isp(creds);

  try {
    return SuccessResponse(await isp.adminDeleteUser(params).promise());
  } catch (err) {
    return ErrorResponse(err);
  }
}

/**
 *
 * @param creds {CaCredentials|null}
 * @param username {string}
 * @param refresh_token {string}
 */
const AuthRefreshToken = async (creds, username, refresh_token) => {

  const isp = get_isp(creds);
  const s_resp = await get_client_secret_c(creds);

  if (s_resp.status === Status.ERROR) {
    return s_resp;
  }

  const secret = s_resp.payload;
  const client_id = USER_POOL_CLIENT_ID;
  const secretHash = crypto.createHmac('SHA256', secret)
    .update(username + client_id).digest('base64');

  const params = {
    AuthFlow: "REFRESH_TOKEN_AUTH",
    ClientId: client_id,
    UserPoolId: getUserPoolId(),
    AuthParameters: {
      REFRESH_TOKEN: refresh_token,
      SECRET_HASH: secretHash
    }
  };

  try {
    return SuccessResponse(await isp.adminInitiateAuth(params).promise());
  } catch (err) {
    return ErrorResponse(err);
  }
}

/**
 * @param creds {CaCredentials|null}
 * @param role_arn {string}
 * @param token {string}
 * @param identity_id {string}
 * @return {GetCredentialsForIdentityResponse}
 */
const GetCredentialsForIdentity = async (
  creds, role_arn, token, identity_id) => {

  const id_service = get_identity_service(creds);

  const login_identity = 'cognito-idp.' + Region.region + '.amazonaws.com/'
    + getUserPoolId();
  const params = {
    IdentityId: identity_id,
    CustomRoleArn: role_arn,
    Logins: {
      [login_identity]: token,
    }
  };

  try {
    return SuccessResponse(
      await id_service.getCredentialsForIdentity(params).promise());
  } catch (err) {
    return ErrorResponse(err);
  }
};

/**
 * @param creds {CaCredentials|null}
 * @param username {string}
 * @param password {string}
 * @param session {string}
 */
const AdminRespondToAuthChallenge = async (creds, username, password, session) => {

  const isp = get_isp(creds);
  const s_resp = await get_client_secret_c(creds);

  if (s_resp.status === Status.ERROR) {
    return s_resp;
  }
  const secret = s_resp.payload;
  const client_id = USER_POOL_CLIENT_ID;
  const secretHash = crypto.createHmac('SHA256', secret)
    .update(username + client_id).digest('base64');

  const challenge_response = {
    USERNAME: username,
    NEW_PASSWORD: password,
    SECRET_HASH: secretHash
  };
  let params = {
    ChallengeName: 'NEW_PASSWORD_REQUIRED',
    ClientId: client_id,
    UserPoolId: getUserPoolId(),
    ChallengeResponses: challenge_response,
    Session: session,
  };

  try {
    return SuccessResponse(await isp.adminRespondToAuthChallenge(params).promise());
  } catch (err) {
    return ErrorResponse(err);
  }
};



module.exports = {
  AdminGetUser, AdminGetUserC,
  AdminUpdateUserAttributes, AdminUpdateUserAttributesC,
  CreateUserPasswordToken, CreateUserPasswordTokenC,
  AdminListUsers, AdminListUsersC,
  AdminListAllUsers, AdminListAllUsersC,
  AdminSetUserPassword, AdminSetUserPasswordC, BootStrap,
  AdminCreateUser, SplitUsername, AuthUser, GetIdentityId,
  BootStrapSUT, AdminDeleteUser, AuthRefreshToken, SetCognitoVerb,
  GetCredentialsForIdentity, AdminRespondToAuthChallenge,
  get_client_secret, get_client_secret_c,
};
